import React from 'react';
import Select, { GroupBase, SingleValue, StylesConfig } from 'react-select';

type DatePickerDropdownOption = {
  label: string | number;
  value: number;
};

const styles: StylesConfig<DatePickerDropdownOption, false, GroupBase<DatePickerDropdownOption>> = {
  control: (base) => ({
    ...base,
    boxShadow: 'none',
    borderRadius: '2px',
    height: '38px',
    minHeight: '38px',
    borderColor: '#e6e6e6',
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: 'none',
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: '0px 8px 0px 0px',
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0px 0px 0px 8px',
    position: 'static',
    fontSize: '14px',
    display: 'flex',
    justifyContent: 'start',
    color: '#000000',
    fontWeight: '500',
  }),
  indicatorsContainer: (base) => ({
    ...base,
  }),
  menu: (base) => ({
    ...base,
    fontSize: '14px',
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: '180px',
    overflowX: 'hidden',
    textAlign: 'left',
  }),
};

const DatePickerDropdown = (
  options: DatePickerDropdownOption[],
  value: DatePickerDropdownOption,
  onChange: (option: SingleValue<DatePickerDropdownOption>) => void
) => {
  return (
    <Select
      options={options}
      value={value}
      onChange={onChange}
      className="date-picker-dropdown"
      classNamePrefix="date-picker-dropdown"
      isSearchable={false}
      styles={styles}
    />
  );
};

export default DatePickerDropdown;
